export enum UserRole {
    recruiter = 'recruiter',
    candidate = 'candidate',
    client = 'client',
}
